export const navSteps = ["Globe", "Locations", "Today", "Method", "Timezone", "Focus"] as const;

export type NavigationStep = (typeof navSteps)[number];

export type UIState = {
  activeStep: number;
  focusedLocationId: string | null;
  isZoomed: boolean;
  selectedLocationId: string | null;
};
